import { API_BASE_URL, PLANET_KEY, COMPOSITE_KEY } from '../../constants/apiConfiguration';

const superagent = require('superagent');
//var rp = require('request').defaults({json: true});


const api_root_planets   = API_BASE_URL + 'getPlanetsData/'; 
const api_root_markets   = API_BASE_URL + 'getMarketData/tbl_';
const api_root_composite = API_BASE_URL + 'getCompositeData/';
const api_root_symbols_markets = API_BASE_URL + 'getSymbolsMarkets/';
const api_root_symbols_planets = API_BASE_URL + 'getSymbolsPlanets/';

const history = {};

export default {
	history: history,

    getBars: async function(symbolInfo, resolution, periodParams, onHistoryCallback, onErrorCallback) {
		const { from, to, firstDataRequest, countBack } = periodParams;
		console.log('[localDBProvider_getBars]: Method call', symbolInfo, resolution, from, to, countBack);
		//var split_symbol = symbolInfo.name.split(/[:/]/)
			/*
			const url = resolution === 'D' ? '/data/histoday' : resolution >= 60 ? '/data/histohour' : '/data/histominute'
			const qs = {
					e: split_symbol[0],
					fsym: split_symbol[1],
					tsym: split_symbol[2],
					toTs:  to ? to : '',
					limit: limit ? limit : 2000, 
					// aggregate: 1//resolution 
				}*/
			// console.log({qs})

			let bars = [];
			let barLoaded=0;
			var symbName=symbolInfo.name;
			var uri=api_root_markets;
			if(symbolInfo.name.includes(PLANET_KEY)){
				var split_symbol = symbolInfo.name.split(/[:/]/);
				if(split_symbol.length>0){
					uri=api_root_planets;
					symbName=split_symbol[1];
				}
			} else if (symbolInfo.name.includes(COMPOSITE_KEY)){
				var split_symbol = symbolInfo.name.split(/[:/]/);
				if(split_symbol.length>0){
					uri=api_root_composite;
					symbName=split_symbol[1];
				}
			}

			var options = {
				uri: `${uri}` + symbName,
				/*
				qs: {
					access_token: 'xxxxx xxxxx' // -> uri + '?access_token=xxxxx%20xxxxx'
				},*/
				headers: {
					'Content-Type': 'application/json' , 
					'User-Agent': 'Request-Promise',
					'Access-Control-Request-Headers': 'Content-Type, Authorization',
					'Access-Control-Allow-Origin': '*'
				},
				resolveWithFullResponse: true,
				//simple: true,
				json: true // Automatically parses the JSON string in the response
			};
			return superagent.get(options.uri)
			.then(data => {
				//__dirname
				try {
					console.log("localDBProvider_data.Response = " +data.body.data.Response);
					if (data.body.data.Response != "Success" || data.body.data.Data.length <= 0) {
						console.log('localDBProvider API error:',data.Message)
						return ([], { noData: true});
					}

					if (data.body.data.Data.length > 0) {
						console.log(`localDBProvider_Actually returned: ${new Date((data.body.data.TimeFrom)).toISOString()} - ${new Date((data.body.data.TimeTo)).toISOString()}`)
					
						data.body.data.Data.forEach(bar => {
							
							//const barTime = bar.time / 1000; // questo perchè le api ritornano i timestamp con millisecondi mentre se si deve limitare tra from e to si deve usare il timestamp in secondi!
							
							//if (barTime >= from && barTime < to) {
								bars = [...bars, {
									time: bar.time, // il valore del tempo è in timestamps con millisecondi !!!
									low: bar.low,
									high: bar.high,
									open: bar.open,
									close: bar.close,
									volume: bar.volume
								}];
								barLoaded += 1;
							//}

						});
						
						let end = false;

						if (firstDataRequest) {
							var lastBar = bars[bars.length - 1]
							history[symbolInfo.name] = {lastBar: lastBar}
						} else {
							end = true;
						}

						console.log(`[localDBProvider_getBars]: returned ${bars.length} bar(s) of ${countBack} requested. BarLoaded=${barLoaded}!`);
						if(!end){
							onHistoryCallback(bars, { noData: false });
						} else {
							onHistoryCallback([], { noData: true });
						}
										
					} else {				
						onHistoryCallback([], { noData: true });				
					}
					
				} catch(err){
					onErrorCallback(err);
				};				

				return bars;

			});
	},

	// chiede la lista dei simboli (mercati + pianeti)
    getSymbols: function(userInput) {
			var uri=api_root_symbols_markets + userInput;
			if(userInput.includes(PLANET_KEY)){
				var split_symbol = userInput.split(/[:/]/);
				uri=api_root_symbols_planets;
				if(split_symbol.length>0){
					uri=uri+split_symbol[1];
				}
			}
			console.log('--debug uri: ' + uri);
			var options = {
				uri: `${uri}`, //+ planetName,
				/*
				qs: {
					access_token: 'xxxxx xxxxx' // -> uri + '?access_token=xxxxx%20xxxxx'
				},*/
				headers: {
					'Content-Type': 'application/json' , 
					'User-Agent': 'Request-Promise',
					'Access-Control-Request-Headers': 'Content-Type, Authorization',
					'Access-Control-Allow-Origin': '*'
				},
				resolveWithFullResponse: true,
				//simple: true,
				json: true // Automatically parses the JSON string in the response
			};
			return superagent.get(options.uri)
			.then(data => {
				//__dirname
                //console.log('getSymbols data resp: ' + {data});
				if (data.Response && data.Response === 'Error') {
					console.log('localDBProvider API error:',data.Message)
					return []
				}
				if (data.body.data.Data.length) {
					var dataInfo = data.body.data.Data.map(el => {
						return {
							symbol: el.symbol, 
							full_name: el.full_name,
							description: el.description,
							exchange: el.exchange,
							ticker: el.ticker,
							type: el.type 
						}
					})
					return dataInfo
				} else {
					//console.log('error1111');
					return []
				}
			})
			.catch(console.error);
	}
	
	
}




